import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';

import { useAppSelector } from 'shared/lib';

import { selectVerificationInstructions } from '../model';

import styles from './VerificationInstructions.module.scss';
import { VerificationInstructionsButtons } from './VerificationInstructionsButtons';

export const VerificationInstructions = () => {
  const verificationInstructions = useAppSelector(selectVerificationInstructions);

  if (!verificationInstructions) return null;

  const { title, textSegments, buttons } = verificationInstructions;

  return (
    <Card>
      <Space
        direction="column"
        size={16}
      >
        <Text
          size={16}
          strong
        >
          {title}
        </Text>
        <div className={styles.textSegments}>
          {textSegments?.map((textSegment) =>
            textSegment.url ? (
              <Link
                key={textSegment.text}
                href={textSegment.url}
                target="_blank"
                rel="noopener,noreferrer"
              >
                {textSegment.text}&nbsp;
              </Link>
            ) : (
              <Text key={textSegment.text}>{textSegment.text}&nbsp;</Text>
            ),
          )}
        </div>
        <VerificationInstructionsButtons buttons={buttons} />
      </Space>
    </Card>
  );
};
